module.exports = __webpack_public_path__ + "img/c.0fca1b99.jpg";